import { useState } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const ROLES = [
  {id:"admin",       lbl:"Administrateur",   ic:"👑"},
  {id:"dispatcher",  lbl:"Dispatcher",        ic:"📋"},
  {id:"technicien",  lbl:"Technicien",        ic:"🔧"},
  {id:"readonly",    lbl:"Lecture seule",     ic:"👁"},
];

export default function ModalInvitation({ T, onClose, onDone }) {
  const [form, setForm]     = useState({prenom:"",nom:"",email:"",role:"technicien"});
  const [step, setStep]     = useState("form"); // form | result
  const [result, setResult] = useState(null);
  const [saving, setSaving] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError]   = useState("");

  const send = async () => {
    if (!form.email||!form.prenom||!form.nom) return setError("Tous les champs sont requis");
    setSaving(true); setError("");
    const res = await fetch(`${BASE}/users/invite`,{method:"POST",headers:h(),body:JSON.stringify(form)}).then(r=>r.json());
    setSaving(false);
    if (res.ok) { setResult(res); setStep("result"); onDone&&onDone(); }
    else setError(res.error||"Erreur");
  };

  const copy = () => {
    navigator.clipboard.writeText(result.link);
    setCopied(true);
    setTimeout(()=>setCopied(false),2000);
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,width:500,display:"flex",flexDirection:"column"}}>

        {/* Header */}
        <div style={{padding:"18px 22px 14px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:T.text}}>✉️ Inviter un utilisateur</div>
            <div style={{fontSize:12,color:T.muted,marginTop:3}}>Un lien de création de mot de passe sera généré</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
        </div>

        <div style={{padding:"20px 22px"}}>
          {step==="form"&&(
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                <div>
                  <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.5px"}}>Prénom *</label>
                  <input value={form.prenom} onChange={e=>setForm(p=>({...p,prenom:e.target.value}))} placeholder="Prénom"
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 13px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
                </div>
                <div>
                  <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.5px"}}>Nom *</label>
                  <input value={form.nom} onChange={e=>setForm(p=>({...p,nom:e.target.value}))} placeholder="Nom"
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 13px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
                </div>
              </div>

              <div>
                <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.5px"}}>Email *</label>
                <input type="email" value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))} placeholder="prenom.nom@gs-group.fr"
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 13px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
              </div>

              <div>
                <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.5px"}}>Rôle</label>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  {ROLES.map(r=>(
                    <button key={r.id} onClick={()=>setForm(p=>({...p,role:r.id}))}
                      style={{padding:"10px 14px",borderRadius:11,border:`1.5px solid ${form.role===r.id?T.accent:T.border}`,background:form.role===r.id?T.accentDim:"transparent",color:form.role===r.id?T.accent:T.muted,fontSize:13,fontWeight:form.role===r.id?700:500,cursor:"pointer",display:"flex",alignItems:"center",gap:8,transition:"all 0.15s"}}>
                      <span>{r.ic}</span><span>{r.lbl}</span>
                    </button>
                  ))}
                </div>
              </div>

              {error&&<div style={{fontSize:12,color:T.danger,padding:"8px 12px",background:`${T.danger}15`,borderRadius:8}}>⚠️ {error}</div>}

              <div style={{display:"flex",gap:10,marginTop:4}}>
                <button onClick={onClose} style={{flex:1,padding:"11px",borderRadius:11,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,cursor:"pointer"}}>
                  Annuler
                </button>
                <button onClick={send} disabled={saving||!form.email||!form.prenom||!form.nom}
                  style={{flex:2,padding:"11px",borderRadius:11,background:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",opacity:saving?0.7:1}}>
                  {saving?"⏳ Génération...":"✉️ Générer le lien d'invitation"}
                </button>
              </div>
            </div>
          )}

          {step==="result"&&result&&(
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              <div style={{textAlign:"center",padding:"16px 0"}}>
                <div style={{fontSize:48,marginBottom:12}}>{result.email_sent?"📧":"🔗"}</div>
                <div style={{fontSize:17,fontWeight:800,color:T.success,marginBottom:6}}>
                  {result.email_sent?"Invitation envoyée par email !":"Lien d'invitation généré !"}
                </div>
                <div style={{fontSize:13,color:T.muted}}>
                  {result.email_sent
                    ? `Un email a été envoyé à ${form.email}`
                    : "Copiez et envoyez ce lien à l'utilisateur"}
                </div>
              </div>

              {/* Lien à copier */}
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 14px"}}>
                <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:"0.5px"}}>🔗 Lien d'invitation (valable 48h)</div>
                <div style={{fontSize:11,color:T.text,wordBreak:"break-all",fontFamily:"monospace",marginBottom:10,lineHeight:1.6}}>
                  {result.link}
                </div>
                <button onClick={copy}
                  style={{width:"100%",padding:"9px",borderRadius:9,background:copied?T.success:`${T.accent}20`,border:`1px solid ${copied?T.success:T.accent}`,color:copied?T.success:T.accent,fontSize:13,fontWeight:700,cursor:"pointer",transition:"all 0.2s"}}>
                  {copied?"✅ Copié !":"📋 Copier le lien"}
                </button>
              </div>

              <div style={{background:`${T.warning}10`,border:`1px solid ${T.warning}30`,borderRadius:10,padding:"10px 14px",fontSize:12,color:T.warning}}>
                💡 L'utilisateur devra scanner un QR code Google Authenticator lors de sa première connexion pour activer le MFA.
              </div>

              <button onClick={onClose}
                style={{padding:"11px",borderRadius:11,background:T.success,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
                ✅ Fermer
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
